/** The part of node's TLS options this sets (its own type, so it fits every app's @types/node) */
export type TDatabaseSslOptions = { ca: string; checkServerIdentity: () => undefined };

/**
 * The `ssl` option for a Postgres connection (TypeORM / node-postgres).
 *
 * `caBase64` is the database server's CA certificate (for Cloud SQL, the instance's server CA),
 * PEM encoded and then base64 encoded onto one line so it survives the Cloud Run YAML templates.
 * With it, the connection is encrypted and the server's certificate must chain to that CA. The
 * hostname isn't checked: services connect to the instance's private IP, while its certificate
 * names the instance, so it could never match. Without it, `enabled` keeps the driver's default
 * verification.
 */
export const databaseSsl = (enabled: boolean, caBase64 = ''): boolean | TDatabaseSslOptions => {
  if (!enabled) return false;
  if (!caBase64.trim()) return true;
  return { ca: Buffer.from(caBase64.trim(), 'base64').toString('utf8'), checkServerIdentity: () => undefined };
};
